import * as TK from 'components/PDP/Details/components/Gallery/components/BigGallery/components/PreviewCarousel/translations/locale.constants';

export const previewCarouselCommonLocale = {
  [TK.PREVIOUS]: 'Previous',
  [TK.NEXT]: 'Next',
};
